import Vue from 'vue'
import { DIALOG_TYPES } from '../../plugins/dialog-types'

export default {
  namespaced: true,
  state: {
    dialog: { ...DIALOG_TYPES.DEFAULT },
    isFullscreen: false,
  },
  getters: {
    getDialog: (state) => {
      return state.dialog
    },
    isFullscreen: (state) => {
      return state.isFullscreen
    },
  },

  mutations: {
    SET_DIALOG(state, dialog) {
      state.dialog = dialog
    },
    CLOSE_DIALOG(state) {
      Vue.set(state, 'dialog', { ...DIALOG_TYPES.DEFAULT })
    },
  },

  actions: {
    closeDialog({ commit }) {
      commit('CLOSE_DIALOG')
    },
  },
}
